import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center pt-20 px-6"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/2bb2f7c05b4cc97dc3874ad28cef653f.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div
          className={`transform transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <div className="mb-8 inline-block">
            <div className="relative w-48 h-48 mx-auto">
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#fcd34d] to-[#facc15] animate-pulse blur-xl opacity-50"></div>
              <img
                src="https://i.postimg.cc/LXhMC45P/rahim.jpg"
                alt="Syed Abdul Raheem - Professional Graphic Designer"
                className="relative w-full h-full rounded-full object-cover border-4 border-white/20 shadow-2xl shadow-[#fcd34d]/30 backdrop-blur-sm"
              />
              <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-[#fcd34d]/20 to-transparent animate-shimmer"></div>
            </div>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 font-['Montserrat'] leading-tight">
            Transforming Ideas into{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#fcd34d] to-[#facc15] animate-shimmer">
              Visual Masterpieces
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-white/80 mb-4 font-['Roboto']">
            Premium Graphic Design by Syed Abdul Raheem
          </p>

          <p className="text-lg md:text-xl text-white/60 mb-12 font-['Roboto'] max-w-3xl mx-auto">
            Logos, Branding, Social Media Designs &amp; More – Bringing Your Vision to Life
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <a
              href="#contact"
              className="group relative px-8 py-4 bg-gradient-to-r from-[#fcd34d] to-[#facc15] text-[#0f172a] rounded-full font-semibold font-['Poppins'] text-lg hover:shadow-2xl hover:shadow-[#fcd34d]/50 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer overflow-hidden"
            >
              <span className="relative z-10">Hire Me</span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#facc15] to-[#fcd34d] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </a>

            <a
              href="#portfolio"
              className="px-8 py-4 bg-white/10 backdrop-blur-md text-white rounded-full font-semibold font-['Poppins'] text-lg border-2 border-white/20 hover:bg-white/20 hover:border-[#fcd34d]/50 hover:shadow-lg hover:shadow-[#fcd34d]/30 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer"
            >
              View Portfolio
            </a>

            <a
              href="https://wa.me/923440674672"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-[#25D366]/20 backdrop-blur-md text-white rounded-full font-semibold font-['Poppins'] text-lg border-2 border-[#25D366]/50 hover:bg-[#25D366]/30 hover:shadow-lg hover:shadow-[#25D366]/30 transition-all duration-300 hover:scale-110 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-[#fcd34d]"></i>
      </div>
    </section>
  );
}
